import { DefaultZIndexes } from 'recharts';

import { primitiveColors } from '../../styles';

export interface IIndexLineChartAxisLineConfig {
	stroke: string;
	strokeWidth: number;
}

export interface IIndexLineChartChartMarginConfig {
	top: number;
	right: number;
	left: number;
	bottom: number;
}

export interface IIndexLineChartConfig {
	gridStroke: string;
	axisStroke: string;
	axisLine: IIndexLineChartAxisLineConfig;
	/** Overrides `axisLine` (line + ticks) for the left Y axis only. */
	yAxisLine?: IIndexLineChartAxisLineConfig;
	/** Overrides `axisLine` (line + ticks) for the right (secondary) Y axis only. */
	secondaryYAxisLine?: IIndexLineChartAxisLineConfig;
	yAxisTickSizePx: number;
	xAxisTickSizePx: number;
	axisTickLabelGapPx: number;
	axisTickLabelClassName: string;
	/** Overrides `axisTickLabelClassName` for the Y axis only (falls back to it when unset). */
	yAxisTickLabelClassName?: string;
	/** Overrides the tick label class for the right (secondary) Y axis only. */
	secondaryYAxisTickLabelClassName?: string;
	lineStrokeWidthPx: number;
	secondaryLineStrokeDasharray: string;
	dotDiameterPx: number;
	selectedPrimaryDotStrokeWidthPx: number;
	chartMargin: IIndexLineChartChartMarginConfig;
	yAxisWidthPx: number;
	secondaryLineZIndex: number;
	primaryLineZIndex: number;
	defaultMinHeightPx: number;
	tooltipContainerClassName: string;
}

export const indexLineChartDefaultConfig: IIndexLineChartConfig = {
	gridStroke: primitiveColors.zinc[200],
	axisStroke: primitiveColors.zinc[500],
	axisLine: {
		stroke: primitiveColors.zinc[500],
		strokeWidth: 2,
	},
	yAxisTickSizePx: 16,
	xAxisTickSizePx: 8,
	axisTickLabelGapPx: 6,
	axisTickLabelClassName:
		'font-sans text-11 leading-lh6 font-normal text-text-secondary',
	lineStrokeWidthPx: 2,
	secondaryLineStrokeDasharray: '6 4',
	dotDiameterPx: 8,
	selectedPrimaryDotStrokeWidthPx: 2,
	chartMargin: { top: 16, right: 16, left: 16, bottom: 0 },
	yAxisWidthPx: 56,
	// Recharts axes default to 500. A series that sits on the domain min
	// shares pixels with the X-axis stroke and disappears unless it paints
	// above that layer. Keep primary above secondary.
	secondaryLineZIndex: DefaultZIndexes.axis + 100,
	primaryLineZIndex: DefaultZIndexes.axis + 200,
	defaultMinHeightPx: 300,
	tooltipContainerClassName:
		'rounded-md border border-divider bg-white px-12 py-10 shadow-md',
};
